import { mergeQueryKeys } from '@lukemorales/query-key-factory';

import appCustomQueries from './appCustomQueries';
import bannerQueries from './bannerQueries';
import cartQueries from './cartQueries';
import categoryQueries from './categoryQueries';
import colorSchemeQueries from './colorSchemeQueries';
import couponQueries from './couponQueries';
import discountQueries from './discountQueries';
import eventQueries from './eventQueries';
import giftBoxQueries from './giftBoxQueries';
import giftCategoryQueries from './giftCategoryQueries';
import giftItemQueries from './giftItemQueries';
import giftOrderQueries from './giftOrderQueries';
import inquiryQueries from './inquiryQueries';
import itemQueries from './itemQueries';
import noticeQueries from './noticeQueries';
import notificationQueries from './notificationQueries';
import orderLogQueries from './orderLogQueries';
import orderQueries from './orderQueries';
import pointQueries from './pointQueries';
import prepaidCadImageQueries from './prepaidCardImageQueries';
import projectQueries from './projectQueries';
import recommendedItemQueries from './recommendedItemQueries';
import shopQueries from './shopQueries';
import stampQueries from './stampQueries';
import termCategoryQueries from './termCategoryQueries';
import termQueries from './termQueries';
import testUserQueries from './testUserQueries';
import userPrepaidCardQueries from './userPrepaidCardQueries';
import userQueries from './userQueries';

const queries = mergeQueryKeys(
  bannerQueries,
  noticeQueries,
  shopQueries,
  categoryQueries,
  itemQueries,
  userQueries,
  giftCategoryQueries,
  giftItemQueries,
  giftBoxQueries,
  userPrepaidCardQueries,
  prepaidCadImageQueries,
  pointQueries,
  cartQueries,
  stampQueries,
  colorSchemeQueries,
  giftOrderQueries,
  appCustomQueries,
  eventQueries,
  couponQueries,
  projectQueries,
  recommendedItemQueries,
  orderLogQueries,
  notificationQueries,
  discountQueries,
  orderQueries,
  termCategoryQueries,
  termQueries,
  inquiryQueries,
  testUserQueries,
);

export default queries;
